import React, { Component, MouseEvent } from 'react';
import ComponentName from 'constant/ComponentName';
import FormicaSearchSelectBox, { FormicaSelectBoxItem } from 'components/custom/FormicaSearchSelectBox';
import ItemToolsMenu from 'components/ItemToolsMenu';
import { AlarmCloseCode, CaseSettings, CloseCaseBulkActionOperation } from 'domain/case/CaseDomains';
import { dispatch, RootState } from 'redux/store';
import { PageState } from 'redux/reducers/PageReducer';
import { UserSystemAttributes } from 'domain/rbac/RbacDomains';
import { ComponentState, setSelectedItems } from 'redux/actions/ComponentActions';
import { CaseState } from 'redux/reducers/CaseReducer';
import { connect } from 'react-redux';
import { changePageFilter, clearPage } from 'redux/actions/PageActions';
import { changeCaseColumns } from 'redux/actions/CaseActions';
import { setAttribute } from 'redux/actions/UserActions';
import { ConnectedProps } from 'react-redux/es/exports';
import { query } from '@trlogic/client-js';
import { TransactionData, TransactionReason } from 'domain/stream/transaction/TransactionDomains';
import { customConfirm } from 'components/custom/CustomPopupConfirm';
import Icon from 'icons/Icon';
import MessageUtil from 'util/MessageUtil';
import LanguageUtil from 'util/LanguageUtil';
import ServiceContainer from 'config/ServiceContainer';
import { ServiceNames } from 'constant/ServiceNames';
import { canPerformBulkClose } from 'util/CaseBulkCloseUtil';
import { TransactionDataExportJob } from 'domain/job/JobDomain';
import moment from 'moment/moment';
import { Skeleton } from 'primereact/skeleton';
import AchService from '../../../service/AchService';
import TransactionPageUtil from 'pages/transaction/TransactionPageUtil';
import Filter = query.Filter;
import and = query.and;
import empty = query.empty;
import or = query.or;
import eq = query.eq;
import inside = query.inside;
import Order = query.Order;

class AchTransactionItemToolsMenu extends Component<Props, State> {
  public state: State = new State();

  private readonly transactionService: AchService = ServiceContainer.getInstance().get(ServiceNames.ACH);

  public render() {
    const { currentCaseSettings, onChangeFilter, loading, filter, user, componentLabel } = this.props;

    const columns = this.getColumn();

    if (loading) {
      return (
        <div className='flex flextransactionService-col w-full h-full gap-2 p-2'>
          <Skeleton width='100%' height='30px' />
          <Skeleton width='100%' height='30px' />
        </div>
      );
    }
    return (
      <>
        <ItemToolsMenu
          key={currentCaseSettings?.dataSource}
          views={false}
          acceptFunc={(e) => this.closeBulk(e, 'NOT_FRAUD')}
          rejectFunc={(e) => this.closeBulk(e, 'FRAUD')}
          acceptLabel={
            user?.activeRiskType == 'fraud'
              ? LanguageUtil.get({ id: 'common.label.notFraud', defaultMessage: 'Not Fraud' })
              : LanguageUtil.get({ id: 'common.label.compliant', defaultMessage: 'Compliant' })
          }
          rejectLabel={
            user?.activeRiskType == 'fraud'
              ? LanguageUtil.get({ id: 'common.label.fraud', defaultMessage: 'Fraud' })
              : LanguageUtil.get({ id: 'common.label.inCompliant', defaultMessage: 'Incompliant' })
          }
          exportVisible={currentCaseSettings != undefined}
          acceptVisible={currentCaseSettings != undefined && canPerformBulkClose(user?.username ?? '', currentCaseSettings, 'ACH')}
          rejectVisible={currentCaseSettings != undefined && canPerformBulkClose(user?.username ?? '', currentCaseSettings, 'ACH')}
          markVisible={false}
          chatVisible={false}
          actionVisible={false}
          exportFunc={this.exportTransactions}
          importVisible={false}
          exportVisibleAlways={true}
          onChangeFilter={onChangeFilter}
          componentLabel={
            componentLabel ??
            LanguageUtil.get({ id: 'common.label.achActivity', defaultMessage: 'ACH Activity' })
          }
          component={ComponentName.ACH}
          componentId={currentCaseSettings?.name ?? 'All'}
          filter={filter}
          preferences={{
            columnPreferencesVisible: false,
          }}
        />
      </>
    );
  }

  private getColumn = () => {
    const {
      case: { columns },
    } = this.props;
    const column = Object.values(columns);
    return column && column.length > 0 ? column[0] : [];
  };

  private closeBulk = async (e: MouseEvent<HTMLButtonElement>, type: string) => {
    const { reason } = this.state;
    const {
      component: { selectedComponentIds },
      user,
      currentCaseSettings,
    } = this.props;
    const selectedIds: CloseCaseBulkActionOperation[] = selectedComponentIds.map((component: TransactionData) => ({
      id: component.id,
      index: component._index,
    }));
    if (!currentCaseSettings) return;
    if (!canPerformBulkClose(user.username, currentCaseSettings, 'ACH')) {
      return;
    }
    customConfirm({
      target: e.currentTarget,
      rejectIcon: <Icon icon={'close'} className={'text-[#1873D5]'} size={20} />,
      acceptIcon: <Icon icon={'check'} className={'text-white'} size={20} />,
      rejectLabel: LanguageUtil.get({ id: 'components.itemToolsMenu.cancel', defaultMessage: 'Cancel' }),
      acceptLabel: LanguageUtil.get({ id: 'components.itemToolsMenu.okay', defaultMessage: 'Okay' }),
      accept: async () => {
        const riskType = user.activeRiskType;
        const _type =
          type == 'FRAUD'
            ? riskType == 'fraud'
              ? TransactionReason.FRAUD
              : TransactionReason.IN_COMPLIANT
            : riskType == 'fraud'
              ? TransactionReason.NOT_FRAUD
              : TransactionReason.COMPLIANT;
        await this.transactionService.closeBulkCase(user, currentCaseSettings.name, selectedIds, _type, this.state.reason, currentCaseSettings);
        MessageUtil.success({
          summary: LanguageUtil.get({ id: `common.label.case`, defaultMessage: 'Case' }),
          detail: <div>{LanguageUtil.get({ id: `messages.success.caseClosed`, defaultMessage: 'Case closed' })}</div>,
        });
        this.setState({ reason: undefined });
        dispatch(setSelectedItems([]));
      },
      reject: async () => {
        this.setState({ reason: undefined });
      },
      message: (
        <FormicaSearchSelectBox
          placeholder={LanguageUtil.get({ id: 'common.input.placeholder.reason', defaultMessage: 'Reason' })}
          options={this.prepareReasonSelectBox(type)}
          value={reason}
          onChange={(e: FormicaSelectBoxItem) => this.setState({ reason: e.value })}
        />
      ),
    });
  };

  private prepareReasonSelectBox = (type: string): any => {
    const { user, currentCaseSettings } = this.props;
    const riskType = user.activeRiskType;
    const _type = type == 'FRAUD' ? (riskType == 'fraud' ? 'FRAUD' : 'IN_COMPLIANT') : riskType == 'fraud' ? 'NOT_FRAUD' : 'COMPLIANT';
    return currentCaseSettings?.closeCodes
      .filter((r) => r.status == _type)
      .map((reason: AlarmCloseCode) => {
        return {
          label: reason.code,
          value: reason.code,
        };
      });
  };

  private exportTransactions = async () => {
    const {
      component: { selectedComponentIds },
      currentCaseSettings,
      caseSettings,
      filter,
      sorts,
      rows,
      currentPage,
      fileName,
    } = this.props;
    try {
      let _query;
      try {
        if (!currentCaseSettings) {
          throw new Error('Alarm domain not found');
        }
        _query = TransactionPageUtil.getTransactionQuery(currentCaseSettings, caseSettings, filter, rows, currentPage, sorts);
      } catch (error: unknown) {
        if (!fileName) {
          throw error;
        }
        _query = this.transactionService.buildTransactionQuery(fileName, currentPage, rows, sorts, filter);
      }
      const SELECTED_IDS_THRESHOLD = 100;
      if (selectedComponentIds.length > 0 && selectedComponentIds.length <= SELECTED_IDS_THRESHOLD) {
        const selectedIds = selectedComponentIds.map((id: TransactionData) => id.id);
        _query.filter = and(_query.filter || empty(), inside('id', selectedIds));
      }
      (_query as any).source = ``;
      // ACH export'u için size/limit olmayacak
      delete (_query as any).top;
      delete (_query as any).limit;
      delete (_query as any).offset;
      delete (_query as any).skip;
      const job: TransactionDataExportJob = {
        type: 'ACH_DATA_EXPORT',
        timestamp: moment().valueOf(),
        status: 'PENDING',
        transaction: currentCaseSettings?.dataSource || '',
        query: _query,
        extension: 'ach',
        path: '',
      };
      await this.transactionService.exportTransactions(job);
      MessageUtil.success({
        summary: LanguageUtil.get({ id: 'common.label.export' }),
        detail: <div>{LanguageUtil.get({ id: 'messages.success.exportScheduled', defaultMessage: 'Export job scheduled' })}</div>,
      });
    } catch (e) {
      console.error(e);
    }
  };
}

class State {
  reason: string | undefined;
  action: string | undefined;
}

interface Props extends ReduxProps {
  componentLabel?: string;
  currentCaseSettings: CaseSettings | undefined;
  caseSettings: Pick<CaseSettings, 'id' | 'name' | 'dataSource' | 'keyField'>[];
  totalRecord: number;
  onChangeFilter: (filter: Filter) => void;
  filter: Filter;
  sorts: Order[];
  rows: number;
  currentPage: number;
  loading: boolean;
  fileName: string;
}

const mapStateToProps = (state: RootState) => ({
  user: state.auth.user,
  page: state.page as PageState,
  attributes: state.auth.attributes as UserSystemAttributes,
  component: state.component as ComponentState,
  case: state.case as CaseState,
});
const connector = connect(mapStateToProps, { clearPage, changePageFilter, changeCaseColumns, setAttribute });
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(AchTransactionItemToolsMenu);
